// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a47ce104","455":"492e6b75","578":"8495d6f6","977":"459ae33c"}[chunkId] + ".chunk.js";
};